module.exports = __webpack_public_path__ + "static/media/81P9dXpJbDL._SL1500_.32299c90.jpg";